import { capitalizeFirstLetter } from './index';

const isProd = process.env.NODE_ENV === 'production';

export const mixpanelTrack = ({
    category, action, ref, value,
}) => {
    // if (isProd) {
    //     const system = document.getElementById('system').value;
    //     mixpanel.track(category, {
    //         action, system, ref, value,
    //     });
    // }
};

export const gaEvent = ({ category, action, value }) => {
    if (isProd) {
        ga('send', 'event', category, action, value);
    }
};

export const logPageView = () => {
    if (isProd) {
        ga('send', 'pageview', typeof window !== 'undefined' && window.location.pathname);
    }
};

export const trackBothEvent = (category, action, value = null) => {
    gaEvent({ category, action, value });
    mixpanelTrack({ category, action, value });
};

export const gaException = (desc, fatal = false) => {
    ga('send', 'exception', {
        exDescription: desc,
        exFatal: fatal,
    });
    mixpanelTrack('Error', { exFatal: fatal, exDescription: desc });
};

export const mixpanelPageTrack = (pathname) => {
    const splitPath = pathname.split('/');
    const page = capitalizeFirstLetter(splitPath[2]);
    mixpanelTrack({ category: page });
};
